import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
/**
 * Angular imports.
 */
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { AnalyticsInterface, EventDataKey } from 'src/app/analytics-event/analytics.model';
import { NUDGE_PARAMETER_EVENTS, PROFILE_ANALYTICS_SCENERIO, PROFILE_EVENT_NAME, SCREEN_NAME_MAP } from 'src/app/analytics-event/profile2.0-analytics.constant';
import { NUMBERS, PROFILE_FIELD_CONSTANT, PROFILE_NUDGE_FIELD_TYPE, PROFILE_NUDGE_PARAMETERS, PROFILE_NUDGE_TYPE, PROFILE_NUDGE_VALIDATION, PROFILE_ACTIONS } from 'src/app/constants/app.constants';
import { GetService } from 'src/app/dataservices/get.service';
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';
import { PostApiService } from 'src/app/dataservices/post-api.service';


@Component({
  selector: 'app-profile-nudge',
  templateUrl: './profile-nudge.component.html',
  styleUrls: ['./profile-nudge.component.scss'],
})
export class ProfileNudgeComponent implements OnInit {

    
    @Input() headingText: string;
    @Input() description: string;

    /**
     * emit action event to perform
     */
    @Output() emitperformAction: EventEmitter<{body: any, action: string,screenName: string, startTime: string, nudgeParameter:string, redirection: string }> = new EventEmitter();



    /**
     * emit action event to perform
     */
    @Output() emitPerformAnalytics: EventEmitter<{eventData: AnalyticsInterface, isHxrCall: boolean, passScreenName: boolean}> = new EventEmitter();





    /**
     * key value object for validation
     */
    public languageObject = {
        'REQUIRED': {
            'EXPERIENCE': {
                'designation': 'key1',
                'organization': 'key2',
                'employmentType': 'key3',
                'location': 'key4',
                'locationType': 'key5',
                'startDate': 'key6',
                'endDate': 'key7',
                'media': 'key8'
            },
            'EDUCATION': {
                'institute': 'key1',
                'degree': 'key2',
                'fieldOfStudy': 'key3',
                'startDate': 'key4',
                'endDate': 'key5',
                'media': 'key6'
            },
            'PRACTICE_DETAILS': {
                'startTime': 'key1',
                'endTime': 'key2',
                'daysOfWeek': 'key3',
                'zipCode': 'key4',
                'city': 'key5',
                'flatHouseNoBuildingCompanyApartment': 'key6'
            },
            'RESIDENTIAL_ADDRESS': {
                'zipCode': 'key1',
                'flatBuilding': 'key2',
                'city': 'key3',
            },
            'MEDICAL_AWARDS': {
                'title': 'key1',
                'media': 'key2',
                'date': 'key3'
            },
            'TRAININGS_RECEIVED': {
                'title': 'key1',
                'media': 'key2',
                'startDate': 'key3',
                'endDate': 'key4'
            },
            'TRAININGS_IMPARTED': {
                'title': 'key1',
                'media': 'key2',
                'startDate': 'key3',
                'endDate': 'key4'
            },
            'CONSULTATION_DETAILS': {
                'consultationsPerDay': 'key1',
                'prescriptionsPerDay': 'key2',
                'drugsPrescribedDetails': 'key3'
            },
            'CIVIL_AWARDS': {
                'title': 'key1',
                'media': 'key2',
                'date': 'key3'
            },
            'POSITION_OF_RESPONSIBILITY': {
                'title': 'key1',
                'media': 'key2',
                'date': 'key3'
            },
            'PAPER_PRESENTATION': {
                'title': 'key1',
                'media': 'key2',
                'date':  'key3'
            },
            'CONFERENCE': {
                'title': 'key1',
                'media': 'key2',
                'venue': 'key3',
                'startDateTime': 'key4',
                'endDateTime': 'key5'
            },
            'BLOG': {
                'title': 'key1',
                'url':  'key2'
            },
            'CERTIFICATION': {
                'title': 'key1',
                'attachment': 'key2',
                'issueDate': 'key3'
            },
            'WORKSHOP': {
                'media': 'key3',
                'title': 'key1',
                'venue': 'key2',
                'startDateTime': 'key4',
                'endDateTime': 'key5'
            },
            'WEBINAR': {
                'title': 'key1',
                'media': 'key2',
                'startDateTime': 'key3',
                'endDateTime': 'key4'
            },
            'SEMINAR': {
                'title': 'key1',
                'media': 'key2',
                'startDateTime': 'key3',
                'endDateTime': 'key4'
            },
            'VOLUNTARY_SERVICE': {
                'title': 'key1',
                'media': 'key2',
                'startDate': 'key3'
            },
            'THESIS': {
                'title': 'key1',
                'date': 'key2'
            },
            'PATENT': {
                'title': 'key1',
                'date': 'key2'
            },
            'PUBLICATION': {
                'title': 'key1',
                'publishingDate': 'key2',
                'attachment': 'key3'
            },
            'UNPUBLISHED_WORK': {
                'title': 'key1'
            }


        }
    };

    /**
     * nudge type
     */
    public nudgeParameter: string;

    /**
     * nudge code
     */
    public nudgeCode: string;
    /**
     * nudge master code
     */
    public nudgeMasterCode: string;

    /**
     * profile action
     */
    public profileActions = PROFILE_ACTIONS

    /**
     * checkbox message
     */
    public checkBoxMessage: string;

    /**
     * form variable
     */
    public nudgeForm = this.formBuilder.group({});
    /**
     * field types for profile nudge
     */
    public fieldType = PROFILE_NUDGE_FIELD_TYPE;
    /**
     * number variable
     */
    public numbers = NUMBERS;

    /**
     * SCREEN NAME
     */
    public screenName: string;

    /**
     * startTime
     */
    public startTime: string;

    /**
     * redirections
     */
    public primaryRedirection: string;

    public secondaryRedirection: string;
    /**
     * time fields
     */
    public startDateTime: number;

    public endDateTime: number;

    public isStartEndDateError = false;


    @Input() eventName: string;

    @Input() profileData: any;

    /**
     * intializing instances
     * @param formBuilder 
     */
    constructor(private formBuilder: FormBuilder, public mls:NewLanguageService, private getService: GetService, private postServ: PostApiService ) {

    }
    /**
     * perform action 
     * @param action 
     */
    performAction(action): void {
        const submitData = {
            'eventName': this.eventName,
            'parameter': this.nudgeParameter,
            'nudgeCode': this.nudgeCode,
            'nudgeMasterCode': this.nudgeMasterCode,
        };
        let redirectUrl = '';
        if (action === PROFILE_ACTIONS.SUBMIT) {
            redirectUrl = this.primaryRedirection;
        }
        else if (action === PROFILE_ACTIONS.DECLINE) {
            redirectUrl = this.secondaryRedirection;
        }
        submitData[this.nudgeParameter.toLowerCase()] = [this.nudgeForm.value];
        this.emitperformAction.emit({body: submitData, action: action, screenName: this.screenName, startTime: this.startTime, nudgeParameter: this.nudgeParameter, redirection:redirectUrl});
    }
    /**
     * function to get event name
     */
    getEventName(nudgeParameter: string, actionType: string): any {
        return NUDGE_PARAMETER_EVENTS[nudgeParameter][actionType];
    }
    /**
     * GET SCREEN NAME
     */
    getScreenName(nudgeParameter): string {
        return SCREEN_NAME_MAP[nudgeParameter];
    }
    /**
        * Get the current time in string.
        */
    getTimeString(): string {
        return new Date().getTime().toString();
    }
    ngOnInit(): void {
        this.nudgeParameter = this.profileData.np;
        this.nudgeMasterCode = this.profileData.nmcode;
        this.nudgeCode = this.profileData.code;
        this.headingText = this.profileData.ttl;
        this.description = this.profileData.desc;
        this.screenName =  SCREEN_NAME_MAP[this.nudgeParameter];
        this.primaryRedirection = this.profileData.pty.pcta;
        this.secondaryRedirection = this.profileData.pty.scta;
        this.startTime = this.getTimeString();
        this.emitAnalyticEvent(PROFILE_EVENT_NAME[this.getEventName(this.nudgeParameter, PROFILE_ANALYTICS_SCENERIO.ENTRY)], 0 , 0, this.screenName ,  this.getTimeString(), this.getTimeString() );
        const details = this.profileData.ndp;
        for (const item of details) {
            const key = item.key;
            let preValue = item.tval;
            if (item.ft === PROFILE_NUDGE_FIELD_TYPE.DROPDOWN_MULTISELECT || item.ft === PROFILE_NUDGE_FIELD_TYPE.DROPDOWN_MULTISELECT_SEARCH) {
                preValue = item.oval
            }
            this.nudgeForm.addControl(key, new FormControl(preValue));
            if (item.pty.mndrty) {
                this.nudgeForm.get(key).addValidators(Validators.required);
            }
            if (key === this.fieldType.TEXT || key === this.fieldType.TEXT_AREA) {
                this.nudgeForm.get(key).addValidators(Validators.maxLength(item.pty.max));
            }
            if (key === this.fieldType.EMAIL) {
                this.nudgeForm.get(key).addValidators(Validators.email);
            }
        }
    }

    getCustomErrorMessage(validation, key): string {
        if (validation === PROFILE_NUDGE_VALIDATION.REQUIRED) {
            const langKey = this.languageObject[validation][this.nudgeParameter][key];
            if (this.nudgeParameter == PROFILE_NUDGE_TYPE.PRACTICE_DETAILS) {
                return this.mls.languageText.profile_nudge_practice_details_required[langKey];
            }
            else if (this.nudgeParameter == PROFILE_NUDGE_TYPE.CERTIFICATION) {
                return this.mls.languageText.profile_nudge_certification_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.CIVIL_AWARDS) {
                return this.mls.languageText.profile_nudge_civil_awards_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.CONFERENCE) {
                return this.mls.languageText.profile_nudge_confrence_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.CONSULTATION_DETAILS) {
                return this.mls.languageText.profile_nudge_consultaion_details_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.EDUCATION) {
                return this.mls.languageText.profile_nudges_education_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.EXPERIENCE) {
                return this.mls.languageText.profile_nudges_experience_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.MEDICAL_AWARDS) {
                return this.mls.languageText.profile_nudge_medical_awards_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.PAPER_PRESENTATION) {
                return this.mls.languageText.profile_nudge_paper_presentation_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.PATENT) {
                return this.mls.languageText.profile_nudge_patent_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.PUBLICATION) {
                return this.mls.languageText.profile_nudge_publication_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.POSITION_OF_RESPONSIBILITY) {
                return this.mls.languageText.profile_nudge_position_of_responsibility_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.RESIDENTIAL_ADDRESS) {
                return this.mls.languageText.profile_nudge_residential_address_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.SEMINAR) {
                return this.mls.languageText.profile_nudge_seminar_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.THESIS) {
                return this.mls.languageText.profile_nudge_thesis_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.TRAININGS_IMPARTED) {
                return this.mls.languageText.profile_nudge_training_imparted_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.TRAININGS_RECEIVED) {
                return this.mls.languageText.profile_nudge_training_received_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.UNPUBLISHED_WORK) {
                return this.mls.languageText.profile_nudge_unpublished_work_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.VOLUNTARY_SERVICE) {
                return this.mls.languageText.profile_nudge_voluntary_service_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.WEBINAR) {
                return this.mls.languageText.profile_nudge_webinar_required[langKey];
            }
            else if(this.nudgeParameter == PROFILE_NUDGE_TYPE.WORKSHOP) {
                return this.mls.languageText.profile_nudge_workshop_required[langKey];
            }
            else if (this.nudgeParameter == PROFILE_NUDGE_TYPE.BLOG) {
                return this.mls.languageText.profile_nudge_blog_required[langKey]
            }
        }
        if (validation === PROFILE_NUDGE_VALIDATION.DATE_TIME ) {
            if (this.startDateTime && this.endDateTime) {
                if (this.startDateTime > this.endDateTime) {
                    if (key === PROFILE_FIELD_CONSTANT.EXPIRIENCE.END_DATE || key === PROFILE_FIELD_CONSTANT.SEMINAR.END_DATE_TIME || key === PROFILE_FIELD_CONSTANT.CERTIFICATION.EXPIRATION_DATE || key ===  PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.END_TIME) {  
                        return this.mls.languageText.profile_basics.key4;       
                    }
                }
            }     
        }
        return '';
    }
    /**
     * 
     * @param length to show border on calendar field
     * @returns 
     */
    toShowErrorOnCalendarField(key): boolean {
        if (this.startDateTime && this.endDateTime) {
            if (this.startDateTime > this.endDateTime) {
                if (key === PROFILE_FIELD_CONSTANT.EXPIRIENCE.END_DATE || key === PROFILE_FIELD_CONSTANT.SEMINAR.END_DATE_TIME || key === PROFILE_FIELD_CONSTANT.CERTIFICATION.EXPIRATION_DATE || key ===  PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.END_TIME) {  
                    return true;       
                }
            }
        }     
        return false;
    }
    getMaxErrorMessage(length: number): string {
        return 'Max character limit reached';
    }
    /**
     * 
     *function to check whther to disable future dates or not
     */
    // toDisableDates(key): boolean {
    //     if (!(key === PROFILE_FIELD_CONSTANT.SEMINAR.END_DATE_TIME || key === PROFILE_FIELD_CONSTANT.CERTIFICATION.EXPIRATION_DATE || key ===  PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.END_TIME) || ((this.nudgeParameter === PROFILE_NUDGE_TYPE.EXPERIENCE && key === PROFILE_FIELD_CONSTANT.EXPIRIENCE.END_DATE) || this.nudgeParameter === PROFILE_NUDGE_TYPE.EDUCATION && key === PROFILE_FIELD_CONSTANT.EDUCATION.END_DATE)) {
    //         return true;
    //     }
    //     return false;
    // }

    toDisableDates(key): boolean {
        if (this.nudgeParameter === PROFILE_NUDGE_PARAMETERS.CERTIFICATION && key === PROFILE_FIELD_CONSTANT.CERTIFICATION.EXPIRATION_DATE) {
            return false;
        }else if (this.nudgeParameter === PROFILE_NUDGE_PARAMETERS.POSITION_OF_RESPONSIBILITY && key === PROFILE_FIELD_CONSTANT.POSTION_OF_RESPONSIBILITY.END_DATE) {
            return false;
        } else if(this.nudgeParameter === PROFILE_NUDGE_PARAMETERS.VOLUNTARY_SERVICE && key === PROFILE_FIELD_CONSTANT.VOLUNTARY_SERVICE.END_DATE){
            return false;
        }
        return true;
      
    }
    emitAnalyticEvent(eventName: EventDataKey, productType: number, productTypeId: number, screenName: string, startTime: string, endTime: string): void {
        const analyticsData = {
            event_name: eventName,
            product_type: 0,
            product_type_id: 0,
            screen_name: screenName,
            start_time: startTime,
            end_time: endTime,    
        };
        this.emitPerformAnalytics.emit({eventData: analyticsData, isHxrCall: false, passScreenName: false});
    }
    /**
     * set element touched;
     */
    elementTouced(item: string): void {
        this.nudgeForm.get(item).markAsTouched();
    }
    /**
     * function to check start and end date relation
     */
    checkForTimeDate(): void {
        if (this.startDateTime && this.endDateTime) {
            if (this.startDateTime > this.endDateTime) {
                this.isStartEndDateError = true;
                return;
            }
            else {
                this.isStartEndDateError = false;
            }
        }
    }
    /**
     * 
     * @param event FF
     * @param formControlName 
     */
    patchSelectedValue(event, formControlName): void {
        if (formControlName === PROFILE_FIELD_CONSTANT.EXPIRIENCE.START_DATE || formControlName === PROFILE_FIELD_CONSTANT.SEMINAR.START_DATE_TIME || formControlName === PROFILE_FIELD_CONSTANT.CERTIFICATION.ISSUE_DATE || formControlName === PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.START_TIME) {
            if (formControlName != PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.START_TIME) {
                this.startDateTime = Date.parse(event);
                this.checkForTimeDate();
            }
            else {
                this.startDateTime = this.convertToTimestamp(event);
                this.checkForTimeDate();
            }
        }
        if (formControlName === PROFILE_FIELD_CONSTANT.EXPIRIENCE.END_DATE || formControlName === PROFILE_FIELD_CONSTANT.SEMINAR.END_DATE_TIME || formControlName === PROFILE_FIELD_CONSTANT.CERTIFICATION.EXPIRATION_DATE || formControlName === PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.END_TIME) {
            if (formControlName != PROFILE_FIELD_CONSTANT.PRACTICE_DETAILS.END_TIME) {
                this.endDateTime = Date.parse(event);
                this.checkForTimeDate();
            }
            else {
                this.endDateTime = this.convertToTimestamp(event);    
                this.checkForTimeDate();      
            }
        }
        this.nudgeForm.get(formControlName).setValue(event);
    }
    /**
     * 
     * @param timeString to timestamp
     * @returns 
     */
    convertToTimestamp(timeString: string): number {
        const today = new Date();
      
        // Split the time string into hours and minutes
        const [hours, minutes] = timeString.split(':').map(Number);
      
        // Set the hours and minutes to today's date
        today.setHours(hours);
        today.setMinutes(minutes);
      
        // Return the timestamp
        return today.getTime();
      }
    /**
     * function to return whether to show check box in case of end date or not
     */
    isCheckBoxToBeShown(fieldName: string): boolean {
        let toShow = false;
        if (fieldName === PROFILE_FIELD_CONSTANT.EXPIRIENCE.END_DATE || fieldName === PROFILE_FIELD_CONSTANT.SEMINAR.END_DATE_TIME || fieldName === PROFILE_FIELD_CONSTANT.CERTIFICATION.EXPIRATION_DATE) {
            switch(this.nudgeParameter) {
                case PROFILE_NUDGE_PARAMETERS.EXPERIENCE: 
                    toShow = true;
                    this.checkBoxMessage = this.mls.languageText.profile_basics.key1;
                    break;
                case PROFILE_NUDGE_PARAMETERS.EDUCATION:
                    toShow = true;
                    this.checkBoxMessage = this.mls.languageText.profile_basics.key3;
                    break;
                case PROFILE_NUDGE_PARAMETERS.POSITION_OF_RESPONSIBILITY:
                    toShow = true;
                    this.checkBoxMessage = this.mls.languageText.profile_basics.key2;
                    break;
                case PROFILE_NUDGE_PARAMETERS.VOLUNTARY_SERVICE:
                    toShow = true;
                    this.checkBoxMessage = 'currently working here';
                    break;
                default:
                    toShow=false;
            }
        }
        return toShow;
    }
}
